<script setup lang="ts">
import AppShell from "./AppShell.vue";

/**
 * The root, and nothing else.
 *
 * Everything visible lives in `AppShell.vue`, which the router fills. Keeping this file empty of
 * chrome is what lets the shell be mounted on its own in a test without dragging in the app's
 * plugin setup.
 */
</script>

<template>
  <AppShell />
</template>
